import { useEffect, useState, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef, ValueFormatterParams } from "ag-grid-community";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AG_GRID_LOCALE_FR, AG_GRID_LOCALE_EN, AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import { Place } from "shared/topchef.types";
import { useBackofficeApi } from 'shared/useBackofficeApi';
import Loading from "pages/shared/loading/Loading";
import { useTranslation } from "react-i18next";

ModuleRegistry.registerModules([AllCommunityModule]);

const ActivatedPlaces = () => {
  const { t, i18n } = useTranslation();
  const [placesLoaded, setPlacesLoaded] = useState(false);
  const [allPlaces, setAllPlaces] = useState<Place[]>([]);
  const backofficeApi = useBackofficeApi();

  useEffect(() => {
    setPlacesLoaded(false);
  }, [backofficeApi.country]);

  const gridLocale = useMemo(() => {
    const language = i18n.language;
    if (language === 'es') return AG_GRID_LOCALE_ES;
    if (language === 'en') return AG_GRID_LOCALE_EN;
    return AG_GRID_LOCALE_FR;
  }, [i18n.language]);

  const columnDefs = useMemo<ColDef<Place>[]>(() => [
    {
      headerName: t('grid.headers.accountName') as string,
      field: "name",
      flex: 1,
    },
    {
      headerName: t('grid.headers.activationDate') as string,
      field: "activationDate",
      flex: 1,
      valueFormatter: (params: ValueFormatterParams) => {
        if (!params.value) return t('lead.notProvided');
        const languageLocale = i18n.language === 'es' ? 'es-ES' : i18n.language === 'en' ? 'en-US' : 'fr-FR';
        return new Date(params.value).toLocaleString(languageLocale, {
          day: "2-digit",
          month: "long",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },
  ], [t, i18n.language]);

  useEffect(() => {
    async function loadActivedPlaces() {
      try {
        const places: Place[] = await backofficeApi.loadActivedPlaces();
        setAllPlaces(places);
        setPlacesLoaded(true);
        console.log(places);
      } catch (error) {
        console.error("Erreur lors du chargement des comptes activés :", error);
      }
    }

    if (!placesLoaded) {
      loadActivedPlaces();
    }
  }, [placesLoaded, backofficeApi]);

  if (!placesLoaded) {
    return <Loading />;
  }

  return (
    <>
      <div className="container p-5">
        <h5 className="mb-3">{t('activatedPlaces.title')}</h5>
        <div className="ag-theme-alpine" id="all_actived_places" style={{ width: '700px', height: '500px', margin: 'auto' }}>
          <AgGridReact
            key={i18n.language}
            rowData={allPlaces}
            columnDefs={columnDefs}
            overlayNoRowsTemplate={t('activatedPlaces.empty') as string}
            overlayLoadingTemplate={`<span>${t('activatedPlaces.loading')}</span>`}
            pagination={true}
            paginationPageSize={20}
            domLayout="normal"
            rowBuffer={10}
            defaultColDef={{
                flex: 1,
                resizable: true,
                autoHeight: true,
            }}
            localeText={gridLocale}
          />
        </div>
      </div>
    </>
  );
};

export default ActivatedPlaces;

